const PATH_SEPARATOR = ' › ';

// Pulse taxonomy ids are pipe-separated paths (`technology|software-engineering|adp`).
export const PULSE_TOPIC_ID_SEPARATOR = '|';

export const pulseTopicOptionLabel = (id: string): string =>
  id.split(PULSE_TOPIC_ID_SEPARATOR).filter(Boolean).map(titleCaseSegment).join(PATH_SEPARATOR);

const titleCaseSegment = (segment: string): string =>
  segment
    .replace(/-+/g, ' ')
    .toLowerCase()
    .replace(/(^|[^a-z])[a-z]/g, (match: string) => match.toUpperCase());
